import React, { useEffect, useRef, useState } from 'react'
import DraggableItem from './dragableItem'
import RenderTable from '../../common/table'
import scissor from '../../../../src/assests/scissorImg.png'
import { clampRectToTicket, getUseableArea } from '../../content/GeneralSettings/GSConstants'
const DragAndDropContainer = (props) => {
  const {
    items,
    isPrePrinted,
    width,
    height,
    headerHeigth,
    footerHeight,
    setItems,
    horizontal,
    vertical,
    marginInfo,
    scale,
  } = props
  // console.log(props)
  const lastTwoItems = items?.filter((item) => item.type !== 'table')?.slice(-2) // Get the last two labels
  const [isSelecting, setIsSelecting] = useState(false)
  const [actionHistory, setActionHistory] = useState([])
  const maxHistoryLength = 5 // Maximum number of actions to keep in history
  const [selectionBox, setSelectionBox] = useState({
    startX: 0,
    startY: 0,
    endX: 0,
    endY: 0,
  })
  const containerRef = useRef(null)
  //useEffect to handle inside click of div selected items should be disselect
  useEffect(() => {
    const handleOutsideClick = (event) => {
      // Check if the click target is inside the container
      const clickedInsideContainer = containerRef.current && containerRef.current.contains(event.target)

      // Check if the click target is an item or a descendant of an item
      const clickedOnItem = items.some((item) => {
        const itemElement = document.getElementById(item.id)
        return itemElement && itemElement.contains(event.target)
      })

      // Update items only if the click is inside the container and not on an item
      if (clickedInsideContainer && !clickedOnItem) {
        const updatedItems = items.map((item) => {
          if (item.type !== 'table') return { ...item, isSelected: false }
          return {
            ...item,
            isSelected: false,
            cells: (item.cells || []).map((row) =>
              row.map((cell) => ({ ...cell, isSelected: false }))
            ),
          }
        })
        setItems(updatedItems)
      }
    }

    document.body.addEventListener('mousedown', handleOutsideClick)

    return () => {
      document.body.removeEventListener('mousedown', handleOutsideClick)
    }
  }, [items, containerRef, setItems])

  const undo = () => {
    if (actionHistory.length > 1) {
      setActionHistory((prevHistory) => {
        const newHistory = prevHistory.slice(0, -1)
        setItems(newHistory[newHistory.length - 1])
        return newHistory
      })
    }
  }
  useEffect(() => {
    // Listen for keyboard events
    const handleKeyDown = (event) => {
      // Check if the key pressed is 'Z' and the 'Ctrl' key is also pressed
      if (event.key === 'z' && event.ctrlKey) {
        // Perform undo operation
        undo()
      }
    }
    // Add event listener for keyboard events
    document.addEventListener('keydown', handleKeyDown)

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [undo])

  useEffect(() => {
    // Save the current state of items to the action history
    setActionHistory((prevHistory) => [...prevHistory, [...items]])
  }, [items])

  const handleDragStart = (e) => {
    // currentTarget, not target: a drag started inside a table cell must still be
    // measured against the table root that carries the item id.
    const rect = e.currentTarget.getBoundingClientRect()
    const data = {
      offsetX: e.clientX - rect.left - 1,
      offsetY: e.clientY - rect.top - 1,
      id: e.currentTarget.id,
    }
    e.dataTransfer.setData('application/json', JSON.stringify(data))
  }
  const handleItemClick = (itemId) => {
    setItems((prevItems) =>
      (prevItems || []).map((item) => {
        const isClicked = item.id === itemId
        const nextSelected = isClicked ? !item.isSelected : false
        if (item.type === 'table') {
          return {
            ...item,
            isSelected: isClicked ? nextSelected : false,
            cells: (item.cells || []).map((row) =>
              row.map((cell) => ({ ...cell, isSelected: false }))
            ),
          }
        }
        return { ...item, isSelected: nextSelected }
      })
    )
  }
  const handleDragOver = (e) => {
    e.preventDefault()
  }
  const handleDrop = (e) => {
    e.preventDefault()
    const droppedItem = e.dataTransfer.getData('application/json')
    const { id: droppedItemId, offsetX, offsetY } = JSON.parse(droppedItem)
    const containerRect = e.currentTarget.getBoundingClientRect()
    const zoom = scale || 1
    let droppedItemLeft = (e.clientX - offsetX - containerRect.left) / zoom
    let droppedItemTop = (e.clientY - offsetY - containerRect.top) / zoom
    const ele = document.getElementById(droppedItemId)
    const bounds = getUseableArea(props.id, marginInfo)
    const clamped = clampRectToTicket(
      droppedItemLeft,
      droppedItemTop,
      ele?.offsetWidth,
      ele?.offsetHeight,
      bounds
    )
    droppedItemLeft = clamped.left
    droppedItemTop = clamped.top
    const draggedItem = items?.find((item) => item.id === droppedItemId)
    if (draggedItem) {
      const updatedItems = items?.map((item) =>
        item.id === draggedItem.id
          ? {
              ...item,
              left: droppedItemLeft,
              top: droppedItemTop,
            }
          : item
      )

      setItems(updatedItems)
    } else {
      document.getElementById(droppedItemId).style.left = droppedItemLeft
      document.getElementById(droppedItemId).style.top = droppedItemTop
    }
  }
  const handleMouseDown = (e) => {
    setIsSelecting(true)
    const containerRect = e.currentTarget.getBoundingClientRect()
    setSelectionBox({
      startX: e.clientX - containerRect.left,
      startY: e.clientY - containerRect.top,
      endX: e.clientX - containerRect.left,
      endY: e.clientY - containerRect.top,
    })
  }

  const handleMouseMove = (e) => {
    if (isSelecting) {
      const containerRect = e.currentTarget.getBoundingClientRect()
      setSelectionBox({
        ...selectionBox,
        endX: e.clientX - containerRect.left,
        endY: e.clientY - containerRect.top,
      })
    }
  }

  const handleMouseUp = () => {
    if (isSelecting) {
      setIsSelecting(false)

      const minX = Math.min(selectionBox.startX, selectionBox.endX)
      const maxX = Math.max(selectionBox.startX, selectionBox.endX)
      const minY = Math.min(selectionBox.startY, selectionBox.endY)
      const maxY = Math.max(selectionBox.startY, selectionBox.endY)

      const updatedItems = items?.map((item) => {
        const itemRect = {
          left: item.left,
          top: item.top,
          right: item.left + 50, // Assuming width and height are both 50
          bottom: item.top + 50,
        }

        const isSelected = itemRect.left < maxX && itemRect.right > minX && itemRect.top < maxY && itemRect.bottom > minY

        return {
          ...item,
          isSelected,
        }
      })

      setItems(updatedItems)
    }
  }

  return (
    <div
      //zoomLevel={zoomLevel}
      ref={containerRef}
      id={props.id}
      style={{
        width: `${width || 200}mm`,
        height: `${height || 100}mm`,
        border: '1px solid #ccc',
        position: 'relative',
        background: 'white',
        margin: 'auto',
        textAlign: 'center',
        transform: `scale(${scale})`,
        transformOrigin: 'top left',
      }}
      onDrop={(e) => handleDrop(e)}
      onDragOver={(e) => e.preventDefault()}
      onMouseMove={(e) => handleMouseMove(e)}
    >
      {/* Border for Top Margin */}
      <div
        style={{
          position: 'absolute',
          top: '0',
          // left: `${marginInfo?.left || 0}px`,
          // right: `${marginInfo?.right || 0}px`,
          left: '0px',
          right: '0px',
          height: `${marginInfo?.up || 0}px`,
          borderBottom: '2px dashed #0086FF', // Adjust color and size as needed
        }}
      ></div>
      {/* Border for Bottom Margin */}
      <div
        style={{
          position: 'absolute',
          bottom: '0',
          // left: `${marginInfo?.left || 0}px`,
          // right: `${marginInfo?.right || 0}px`,
          left: '0px',
          right: '0px',
          height: `${marginInfo?.down || 0}px`,
          borderTop: '2px dashed #0086FF', // Adjust color and size as needed
        }}
      ></div>
      {/* Border for Left Margin */}
      <div
        style={{
          position: 'absolute',
          left: '0',
          // top: `${marginInfo?.up || 0}px`,
          // bottom: `${marginInfo?.down || 0}px`,
          top: '0px',
          bottom: '0px',
          width: `${marginInfo?.left || 0}px`,
          borderRight: '2px dashed #0086FF', // Adjust color and size as needed
        }}
      ></div>
      {/* Border for Right Margin */}
      <div
        style={{
          position: 'absolute',
          right: '0',
          // top: `${marginInfo?.up || 0}px`,
          // bottom: `${marginInfo?.down || 0}px`,
          top: '0px',
          bottom: '0px',
          width: `${marginInfo?.right || 0}px`,
          borderLeft: '2px dashed #0086FF', // Adjust color and size as needed
        }}
      ></div>
      <div
        style={{
          borderBottom: `1px solid #ccc`,
          position: 'absolute',
          top: `${headerHeigth}mm`, //need to add margintop
          left: '0',
          right: '0',
        }}
      ></div>
      <div
        style={{
          borderTop: `1px solid #ccc`,
          position: 'absolute',
          bottom: `${footerHeight}mm`,
          left: '0',
          right: '0',
        }}
      ></div>
      {/*Separation Horizontal Line */}
      {/* <div
        style={{
          position: 'absolute',
          display: !horizontal || horizontal === '0' ? 'none' : '',
          top: `${horizontal}mm`,
          left: `${0}mm`,
          width: `${width}mm`, //ticket width
          height: '1px',
          backgroundColor: 'gray',
          borderBottom: `1px dashed #ccc`,
          backgroundImage: 'url(http://i.stack.imgur.com/cXciH.png)',
        }}
      ></div> */}
      {/*Separation Horizontal Line with scissors*/}
      <div
        style={{
          height: '43px',
          width: '100%',
          backgroundImage: 'url("http://i.stack.imgur.com/cXciH.png")',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: '18px 12px',
          position: 'relative',
          top: `${horizontal - 6}mm`,
          display: !horizontal || horizontal === '0' ? 'none' : '',
        }}
      ></div>
      <div
        style={{
          position: 'relative',
          top: `${horizontal - 6}mm`, //horizontal-43px+22px=6mm
          borderBottom: `1px dashed black`,
          marginTop: ' -22px',
          display: !horizontal || horizontal === '0' ? 'none' : '',
        }}
      ></div>

      {/*Separation Vertical Line */}
      {/* <div
        style={{
          position: 'absolute',
          top: `${0}mm`,
          left: `${vertical}mm`,
          display: !vertical || vertical === '0' ? 'none' : '',
          width: '1px',
          height: `${height}mm`, //ticket height
          backgroundColor: 'gray',
          borderLeft: `1px dashed #ccc`,
        }}
      ></div> */}
      <div
        style={{
          width: '43px',
          height: '100%',
          backgroundImage: 'url("http://i.stack.imgur.com/cXciH.png")',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: '18px 12px',
          position: 'relative',
          left: `${vertical - 6}mm`,
          // display: 'inline-block',
          transform: 'rotate(270deg)',
          display: !vertical || vertical === '0' ? 'none' : 'inline-block',
        }}
      ></div>
      <div
        style={{
          position: 'relative',
          left: `${vertical - 12}mm`,
          borderRight: `1px dashed black`,
          marginRight: '-22px',
          height: '100%',
          display: !vertical || vertical === '0' ? 'none' : 'inline-block',
        }}
      ></div>
      {items?.map((item) =>
        item.type === 'table' ? (
          <RenderTable
            key={item.id}
            {...item}
            handleDragStart={handleDragStart}
            handleDragOver={handleDragOver}
            handleItemClick={handleItemClick}
            items={items}
            setItems={setItems}
            marginInfo={marginInfo}
            containerId={props.id}
          />
        ) : (
          <DraggableItem
            key={item.id}
            {...item}
            handleDragStart={handleDragStart}
            handleDragOver={handleDragOver}
            handleItemClick={handleItemClick}
            items={items}
            setItems={setItems}
            isPrePrinted={isPrePrinted}
          />
        )
      )}
      {isPrePrinted &&
        lastTwoItems.map((item) => (
          <DraggableItem
            key={item.id}
            {...item}
            handleDragStart={handleDragStart}
            handleDragOver={handleDragOver}
            handleItemClick={handleItemClick}
            items={items}
            setItems={setItems}
          />
        ))}
    </div>
  )
}

export default DragAndDropContainer
